// extracted by mini-css-extract-plugin
module.exports = {"group":"DropdownGroup-styles_group__2qTEn","name":"DropdownGroup-styles_name__1kvyz"};